import React from 'react'
import './ReSchedulePopupStyle.css'
import Button from '../../Button/Button'
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import SlotCard from '../../Slotcard/SlotCard';
import moment from 'moment/moment';
import TextArea from '../../TextArea/TextArea';
import Skeleton from 'react-loading-skeleton';

const ReSchedulePopup = ({ isActive, isSlotDatesFetching, isSlotsFetching, handleCloseReschdule, data, error, mentorSlotDates, mentorSlots, selectedDate, reason, selectedSlot, handleSelectDate, handleSelectSlot, handleDiscard, handleConfirm, handleReasonChange }) => {

    const navigationPrevRef = React.useRef(null)
    const navigationNextRef = React.useRef(null)
    const navigationNextRefNew = React.useRef(null);
    const navigationPrevRefNew = React.useRef(null);

    return (
        <div className={`popupWrapper poupviewtab  ${isActive && "active"}`}>
            <div className={`popupContainer Rcbgcontain`}>
                <div className="popupBody">
                    <span className="closebtn mb10">
                        <img src="/assets/svg/close.svg" alt="" onClick={handleCloseReschdule} />
                    </span>
                    <div className="headingpoup">
                        <h3>Reschedule Session</h3>
                    </div>

                    <div className='flex WrapReschedulepoup'>
                        <div className="ReSchedulepoupleft">
                            <div className="menterdataSession">
                                <p className='text2 mb-30'>Web conferencing details chosen as per Indian Standard Time are as follows:</p>
                                <div className="CallDetailsNameData">
                                    <span className="Menteespan Designspan">Mentee</span>
                                    <div className="NameDetails mt10">
                                        <h3 className="namelink pointer mb-5">{data?.firstName ? `${data?.firstName} ${data?.lastName}` : "---"}</h3>
                                        <p className="text2">{data?.profession?.designation ? data?.profession?.designation : "---"}, {data?.profession?.company ? data?.profession?.company : "---"}</p>
                                    </div>

                                </div>
                                {data?.languages?.length > 0 && <div className="flex mt-15 gap-10">
                                        {data?.languages?.map((item, index) => (
                                        <div className="coursesTag" key={index}>{item?.name ?? "---"}</div>
                                        ))}
                                </div>}
                            </div>
                            <div className="BodyViewSlotWrapper">
                                <h3 className='text2 mt-30'>Select Date</h3>
                                <div className="Bodymentordatawrap SwiperBodyWrappper">
                                    <div className="NextBtn swiperbtn" ref={navigationNextRef}>
                                        <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fillRule="evenodd" clipRule="evenodd" d="M8.46967 5.96967C8.76256 5.67678 9.23744 5.67678 9.53033 5.96967L15.5303 11.9697C15.8232 12.2626 15.8232 12.7374 15.5303 13.0303L9.53033 19.0303C9.23744 19.3232 8.76256 19.3232 8.46967 19.0303C8.17678 18.7374 8.17678 18.2626 8.46967 17.9697L13.9393 12.5L8.46967 7.03033C8.17678 6.73744 8.17678 6.26256 8.46967 5.96967Z" fill="black" />
                                        </svg>
                                    </div>
                                    <Swiper
                                        modules={[Navigation]}
                                        slidesPerView={2}
                                        autoHeight={true}
                                        spaceBetween={10}
                                        direction='horizontal'

                                        breakpoints={{
                                            640: {
                                                slidesPerView: 2,
                                            },
                                            768: {
                                                slidesPerView: 3,
                                            }
                                        }}
                                        onSwiper={(swiper) => {
                                            // Delay execution for the refs to be defined
                                            setTimeout(() => {
                                                // Override prevEl & nextEl now that refs are defined
                                                swiper.params.navigation.prevEl = navigationPrevRef.current
                                                swiper.params.navigation.nextEl = navigationNextRef.current

                                                // Re-init navigation
                                                swiper.navigation.destroy()
                                                swiper.navigation.init()
                                                swiper.navigation.update()
                                            })
                                        }}
                                        navigation={{
                                            // Both prevEl & nextEl are null at render so this does not work
                                            prevEl: navigationPrevRef.current,
                                            nextEl: navigationNextRef.current,
                                        }}
                                        onBeforeInit={(swiper) => {
                                            swiper.navigation.nextEl = navigationNextRef.current;
                                            swiper.navigation.prevEl = navigationPrevRef.current;
                                        }}

                                        className="mySwiper">
                                        <div className="SlotAreaWrapperallCard">
                                            {isSlotDatesFetching ?
                                <>
                                {[1,2].map(item => (
                                    <label className={`SlotCardWrapperBox`}>
                                    <input type="radio"/>
                                    <div className="SlotCardWrapper">
                                        <div className="bodySlotarea">
                                            <span className='Weekdays'>{<Skeleton width={"40px"} />}</span>
                                            <h4>{<Skeleton width={"50px"} />}</h4>
                                        </div>
                                        <div className={`FooterSlotCard`} >
                                        <Skeleton width={"70px"} />
                                        </div>
                                    </div>
                                </label>
                                ))}
                                </>
                             :mentorSlotDates?.length > 0 ?  mentorSlotDates?.map((item, index) => (
                                                <SwiperSlide key={index}>  <SlotCard checked={item?.slotsDate === selectedDate} onChange={() => handleSelectDate(item?.slotsDate)} slotsCount={item?.slotsCount ?? 0} day={item?.slotsDate ? moment(item?.slotsDate).format("ddd") : "---"} date={item?.slotsDate ? moment(item?.slotsDate).format("DD MMM") : "---"} /> </SwiperSlide>
                                            )) : "No Slots Available"}
                                        </div>
                                    </Swiper>
                                    <div className="PreBtn swiperbtn" ref={navigationPrevRef}>
                                        <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fillRule="evenodd" clipRule="evenodd" d="M15.5303 5.96967C15.8232 6.26256 15.8232 6.73744 15.5303 7.03033L10.0607 12.5L15.5303 17.9697C15.8232 18.2626 15.8232 18.7374 15.5303 19.0303C15.2374 19.3232 14.7626 19.3232 14.4697 19.0303L8.46967 13.0303C8.17678 12.7374 8.17678 12.2626 8.46967 11.9697L14.4697 5.96967C14.7626 5.67678 15.2374 5.67678 15.5303 5.96967Z" fill="black" />
                                        </svg>
                                    </div>
                                    
                                </div>
                            </div>
                            { mentorSlots?.length > 0 &&
                            <>
                            <div className="Dashborder"></div>

                            <h3 className='text2 mt-30'>Select Time</h3>

                            <div className="SlotAreaWrapperallCard SwiperBodyWrappper">
                                <div className="NextBtn swiperbtn" ref={navigationNextRefNew}>
                                    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fillRule="evenodd" clipRule="evenodd" d="M8.46967 5.96967C8.76256 5.67678 9.23744 5.67678 9.53033 5.96967L15.5303 11.9697C15.8232 12.2626 15.8232 12.7374 15.5303 13.0303L9.53033 19.0303C9.23744 19.3232 8.76256 19.3232 8.46967 19.0303C8.17678 18.7374 8.17678 18.2626 8.46967 17.9697L13.9393 12.5L8.46967 7.03033C8.17678 6.73744 8.17678 6.26256 8.46967 5.96967Z" fill="black" />
                                    </svg>
                                </div>
                                <Swiper className={'newSwiperSlider'}
                                    modules={[Navigation]}
                                    slidesPerView={2.4}
                                    autoHeight={true}
                                    spaceBetween={10}
                                    
                                    breakpoints={{
                                        640: {
                                            slidesPerView: 1,
                                        },
                                        768: {
                                            slidesPerView: 3,
                                        },
                                        1024: {
                                            slidesPerView: 3,
                                        },
                                    }}
                                    onSlideChange={() =>
                                        console.log('slide change')}
                                        onSwiper={(swiper) => {
                                            // Delay execution for the refs to be defined
                                            setTimeout(() => {
                                                // Override prevEl & nextEl now that refs are defined
                                                swiper.params.navigation.prevEl = navigationPrevRefNew.current
                                                swiper.params.navigation.nextEl = navigationNextRefNew.current
                                                
                                                // Re-init navigation
                                                swiper.navigation.destroy()
                                                swiper.navigation.init()
                                                swiper.navigation.update()
                                            })
                                        }}
                                        navigation={{
                                            // Both prevEl & nextEl are null at render so this does not work
                                            prevEl: navigationPrevRefNew.current,
                                            nextEl: navigationNextRefNew.current,
                                        }}
                                        onBeforeInit={(swiper) => {
                                            swiper.navigation.nextEl = navigationNextRefNew.current;
                                            swiper.navigation.prevEl = navigationPrevRefNew.current;
                                        }}>

                                    <div className="SlotAreaWrapperallCard">
                                        {isSlotsFetching ?
                             <>
                             {[1,2,3,4].map(item => (
                                 <label lassName="TimeSlotsCrad" >
                                 {/* <input type="radio"/> */}
                                 <div className='mainSlotBox'>
                                     <Skeleton width={"70px"} />
                                 </div>
                                 {/* <div className="hoverDelete" onClick={() => handleDeletePopup(item?.id)}>
                                     <img src="../assets/svg/trashWhite.svg" alt="" />
                                     Remove
                                 </div> */}
                             </label>
                             ))}
                             </>
                         : mentorSlots?.length > 0 ? mentorSlots?.map((item, index) => (
                                            <SwiperSlide key={index}>
                                            <label className="TimeSlotsCrad" htmlFor={'pp'+index} >
                                                <input id={'pp'+index} name='pp' type="radio" checked={selectedSlot === item?.id} onChange={() => handleSelectSlot(item?.id)} />
                                                <div className='mainSlotBox'>
                                                    {moment(item?.startTime).utcOffset("-00:00").format("h:mm a") ? moment(item?.startTime).utcOffset("-00:00").format("h:mm a") : "---"}
                                                </div>
                                            </label>
                                        </SwiperSlide>
                                        )) : "No date selected"}
                                    </div>

                                </Swiper>
                                    
                                <div className="PreBtn swiperbtn" ref={navigationPrevRefNew}>
                                    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fillRule="evenodd" clipRule="evenodd" d="M15.5303 5.96967C15.8232 6.26256 15.8232 6.73744 15.5303 7.03033L10.0607 12.5L15.5303 17.9697C15.8232 18.2626 15.8232 18.7374 15.5303 19.0303C15.2374 19.3232 14.7626 19.3232 14.4697 19.0303L8.46967 13.0303C8.17678 12.7374 8.17678 12.2626 8.46967 11.9697L14.4697 5.96967C14.7626 5.67678 15.2374 5.67678 15.5303 5.96967Z" fill="black" />
                                    </svg>
                                </div>
                            </div>
                            </>}
                            
                        </div>

                        <div className="ReSchedulepoupright">
                            <div className="Rstextpoup">
                                <p className='text3'>Kindly state the purpose for call or the specifics of your discussion:</p>
                            </div>

                            <TextArea placeholder={'Example: Due to my unavailability'} labelName="Reason of rescheduling" className={'textareaRc'} value={reason} onChange={handleReasonChange} errorMessage={error["reason"]} />
                        </div>
                    </div>

                    <div className='flex-center gap-20 mt-20 Rcbuttonfooter'>
                        <Button name={'Discard'} className={'GreyFillButton'} onClick={handleDiscard} />
                        <Button name={'Confirm'} className={'DarkblueFillButton'} onClick={handleConfirm} />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ReSchedulePopup